
    import { Vue, Component } from 'vue-property-decorator'
    import { mapGetters, mapState } from 'vuex'
    import { License } from '@/app/license/entities/license.entity'
    import LanguageButton from "@/app/common/components/language-button.vue"
    import NavigationDrawerMenu from "@/app/common/components/layout/navigation-drawer-menu.vue"

    @Component({
        components: { NavigationDrawerMenu, LanguageButton },
        computed: {
            ...mapState('license', ['license', 'languages']),
            ...mapGetters('auth', ['isAuthenticated']),
        }
    })
    export default class TopMenu extends Vue {
        license!: License
        isAuthenticated!: boolean
    }
